import { useUiStore } from '../../stores/ui/store';
import { RouteLocationNormalized } from 'vue-router';
import { IRouteMeta } from 'src/core/models/routing';
import { ROUTE_PATH_PROPERTIES } from '@/shared/constants';
import useNotifications from '../composable/use-notifications';
import usePermissionChecker from '../composable/use-permission-checker';
import useRoutePermissionsUtils from '../router-utils/route-permissions-utils';
import { getAccountSignInUrl, shouldDeferAutherisBrowserRedirect } from '../utils/autheris-browser';

function isAutherisLoginRoute(to: RouteLocationNormalized): boolean {
  if (to.path.toLowerCase() === '/login') return true;
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname.toLowerCase();
  if (path === '/login' || path.startsWith('/account/')) return true;
  return /^#\/login([/?#]|$)/i.test(window.location.hash);
}

export default async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {

  const { showError } = useNotifications();
  const { getRoutePermissions } = useRoutePermissionsUtils();
  const { hasPermission } = usePermissionChecker();
  const uiStore = useUiStore();

  if (isAutherisLoginRoute(to)) {
    return true;
  }

  const forceSignInRedirect = () => {
    if (!shouldDeferAutherisBrowserRedirect()) {
      const signInUrl = getAccountSignInUrl();
      try {
        window.location.href = signInUrl;
        setTimeout(() => window.location.replace(signInUrl), 50);
      } catch {
        window.location.assign(signInUrl);
      }
    }
    return false;
  };

  if (!uiStore.sessionUserInfo) {
    try {
      await uiStore.loadUserInfo();
    } catch {
      return forceSignInRedirect();
    }
  }

  const permissions = getRoutePermissions(to, (to.meta as IRouteMeta).containerType);

  let hasPermissionResult = hasPermission(permissions?.readPermission);
  if (!hasPermissionResult) {
    showError('core.unauthorizedMsg', 'Error');
    return false;
  }

  // Special handling for properties route
  if (to.path.endsWith(ROUTE_PATH_PROPERTIES)) {
    hasPermissionResult = hasPermission(permissions?.writePermission);

    if (!hasPermissionResult) {
      showError('core.unauthorizedMsg', 'Error');
      return { path: from.fullPath, replace: true };
    }
  }

  return hasPermissionResult;
};
